module.exports = __webpack_public_path__ + "img/D2F7.1a0fb672.jpg";